import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

export const useUpdateEffect = (effect: EffectCallback, deps: DependencyList) => {
  const isFirstMountRef = useRef(true);
  const isFirstMount = isFirstMountRef.current;

  isFirstMountRef.current = false;

  useEffect(() => {
    if (!isFirstMount) {
      return effect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
